<div class="addonContainer">
    <div class="addon_name">
        <p>{{foodName}}</p>
    </div>

    <div style="margin-top: 2%;">
        <div class="variants-heading">
            Variants
        </div>
        <div class="row options" style="padding-left: 10px;" *ngFor="let item of options; let i=index">
            <div class="col-9">
                {{item.option_name}}
            </div>
            <div class="col-3 d-flex">
                <div style="margin-left:-6px"> £ {{item.option_price}}</div>
                <mat-radio-button color="primary" [value]="i" [checked]="variantCheckFunc(item,i)"
                    style="padding-left: 10px"
                    (change)="removeOldData();sendAddondetails(item.option_id,item.option_name,item.option_price,i)">
                </mat-radio-button>
            </div>
        </div>
    </div>

    <div>
        <div class="variants-heading">
            Add On
        </div>
    </div>

    <!-- <div *ngIf="addonListShow">
        <div class="row options addonPadding" style="padding-left: 10px;" *ngFor="let item of addonList; let i=index">
            <ng-container>
                <div class="col-9">
                    {{item.addon_name}}
                </div>
                <div class="col-3 d-flex">
                    <div style="margin-left:-6px"> £ {{valueAddonMoney(item.addon_price)}}</div>
                    <div class="check">
                        <mat-checkbox class="example-margin" style="padding-left: 10px" [value]="item.dish_addon_id"
                            [id]="item.dish_addon_id" [checked]="addOnCheckFunc(item)"
                            (change)="select_addons(item.dish_addon_id,item.restaurant_dish_addon_optionId,item.addon_name,item.dish_addon_option_price,$event)">
                        </mat-checkbox>
                        <label [for]="item.addon_name"></label>
                    </div>
                </div>
            </ng-container>
        </div>
    </div> -->

    <div *ngIf="showAddonData">
        <div class="row options addonPadding" style="padding-left: 10px;"
            *ngFor="let item of addonBasedonOptionId; let i=index">
            <ng-container>
                <div class="col-9">
                    {{item.addon_name}}
                </div>
                <div class="col-3 d-flex">
                    <div style="margin-left:-6px"> £ {{valueAddonMoney(item.dish_addon_option_price)}}</div>
                    <div class="check">
                        <mat-checkbox class="example-margin" style="padding-left: 10px" [id]="item.dish_addon_id"
                            [value]="item.dish_addon_id" [checked]="addOnCheckFunc(item)"
                            (change)="select_addons(item.dish_addon_id,item.restaurant_dish_addon_optionId,item.addon_name,item.dish_addon_option_price,$event)">
                        </mat-checkbox>
                        <label [for]="item.addon_name"></label>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

</div>
<div class="" style="position:sticky;bottom: 0px;">
    <!-- <button class="btn-addToCart" (click)=dataPass() > <span style="padding-left:10px;">£ {{totalDishPriceAfterAddons}} </span> <span style="padding-right: 10px;"> Add Item</span></button> -->
    <button class="btn-addToCart" (click)=dataPass() [disabled]="disableAddBtn">
        <div class="col-9" style="text-align: justify;">
            £ {{totalDishPriceAfterAddons}}
        </div>
        <div class="col-3 d-flex" style="padding-left: 15px;">
            Update
        </div>
        <!-- <span style="padding-left:10px;"></span> <span style="padding-right: 13px;"> </span> -->
    </button>
</div>
<style>
    .addonContainer {
        overflow: scroll;
        width: 100%;
        overflow-x: hidden;
        height: 100%;
    }

    .float-right {
        margin-top: -20px !important;
    }

    .addon_name p {
        font-size: 18px;
        color: #3C3C3C;
        line-height: 23px;
        font-weight: 500;
        padding: 10px;
        text-align: center;
        border-bottom: 3px solid #EFEFEF !important;
        text-transform: capitalize;
    }

    .addonPadding {
        padding-top: 10px !important;
    }

    #textbox {
        background-color: #479943;
        height: 40px;
        width: 275px;
        padding: 8px;
        color: white;
        font-weight: 600;
        margin-top: 12px;
    }

    .options {
        color: #737373 !important;
        font-size: 15px !important;
        padding-top: 2%;
    }

    .options .col-3 {
        /* padding-top:5px; */
        float: right;
    }

    .options .col-9 {
        padding-left: 15px !important;
        /* padding-top: 2px !important; */
    }

    .alignleft {
        float: left;
    }

    .disabled {
        color: #bdbdbd !important;
    }

    .alignright {
        float: right;
    }

    .select_add {
        color: #737373 !important;
        font-size: 15px !important;
    }

    .select_add .col-9 {
        /* margin-left: -20px; */
        font-size: 16px !important;
    }

    .select_add .col-3 {}

    ::ng-deep .mat-radio-button.mat-primary.mat-radio-checked .mat-radio-outer-circle {
        border-color: #54AC58;
    }

    ::ng-deep .mat-radio-button.mat-primary .mat-radio-inner-circle {
        background-color: #54AC58;
    }

    ::ng-deep .mat-radio-label-content {
        -webkit-user-select: auto;
        -moz-user-select: auto;
        -ms-user-select: auto;
        user-select: auto;
        display: inline-block;
        order: 0;
        color: #737373 !important;
        line-height: inherit;
        padding-left: 4px !important;
        padding-right: 0;
    }

    ::ng-deep.mat-radio-outer-circle {
        width: 18px !important;
        height: 18px !important;
    }

    ::ng-deep.mat-radio-inner-circle {
        width: 18px !important;
        height: 18px !important;
    }

    ::ng-deep.mat-bottom-sheet-container {
        padding: 0px !important;
        min-width: 100vw;
        box-sizing: border-box;
        display: block;
        outline: 0;
        max-height: 600vh !important;
        overflow: auto;
        border-top-left-radius: 16px !important;
        border-top-right-radius: 16px !important;
    }

    ::ng-deep.mat-bottom-sheet-container-large {
        /* min-width: 350px;
        max-width: calc(100vw - 256px); */
        min-width: 380px;
        max-width: 380px;
        min-height: 100px !important;
        max-height: 300px !important;
    }

    ::ng-deep.mat-bottom-sheet-container-xlarge {
        /* min-width: 361px !important;
          max-width: calc(100vw - 384px); */
        min-width: 380px;
        max-width: 380px;
    }

    ::ng-deep::-webkit-scrollbar {
        display: none !important;
    }

    input[type=checkbox] {
        /* display: none; */
    }

    input[type=checkbox] {
        position: absolute;
        /* top: -9999px; */
        left: 50px;
        width: 18px;
        height: 19px;
    }

    .check {
        /* margin-left: -23px !important; */
    }

    .cart[_ngcontent-rpd-c19] {
        position: relative;
        padding: 0 0;
        border: 1px solid transparent;
        border-radius: .25rem;
        width: 124px;
        height: 32px;
    }

    .cart-success {
        background-color: #479943;
        color: #ffff;
        width: 260px;
        font-weight: 600;
        /* text-align: center; */
        padding-top: 3px;
    }

    .cartstick {
        background: white;
        bottom: 0;
        z-index: 1;
    }

    .title_options {
        font-size: 17px;
        font-weight: 500;
        color: #479943;
        margin-top: 4px;
        margin-bottom: 5px;
    }

    .moreTitle {
        cursor: pointer;
        border: none;
        background: white;
        font-size: 15px;
        border-bottom: 2px solid;
        color: #479943;
        font-weight: 500;
    }

    .variants-heading {
        font-size: 16px;
        line-height: 21px;
        color: #4E4E4E;
        font-weight: 500;
        background: #F2F5F7;
        padding: 8px 0px 6px 15px;
    }

    .switch {
        -webkit-tap-highlight-color: transparent
    }

    input[type="checkbox"]:focus {
        outline: 0;
    }

    .btn-addToCart {
        background: linear-gradient(to right, #62AF55, #4AB07F);
        font-family: Roboto;
        height: 40px;
        color: #ffff;
        font-weight: 500;
        font-size: 14px;
        border: none;
        width: 100%;
        line-height: 19px;
        display: flex;
        justify-content: space-between;
        padding-top: 10px;
    }

    ::ng-deep .mat-checkbox-checked.mat-accent .mat-checkbox-background,
    .mat-checkbox-indeterminate.mat-accent .mat-checkbox-background {
        background-color: white;
        border: 2px solid #54AC58;
    }

    ::ng-deep .mat-checkbox-checkmark-path {
        stroke: #54AC58 !important;
        stroke-width: 5px;
    }

    button:disabled {
        cursor: not-allowed;
        pointer-events: all !important;
    }
</style>